"use client";

import { useEffect } from "react";

export default function HudsonConsoleMessage() {
  useEffect(() => {
    const meta = document.querySelector('meta[name="x-image-tag"]') as HTMLMetaElement | null;
    const imageTag = meta?.content || process.env.NEXT_PUBLIC_IMAGE_TAG;
    const tagSuffix = imageTag ? ` (${imageTag})` : "";
    console.log(
      `Booking Engine ${process.env.NEXT_PUBLIC_APP_VERSION}${tagSuffix} expertly developed by the team at Hudson Software, https://hudsonltd.com/`,
    );
  }, []);

  return null;
}
